export default __webpack_public_path__ + "static/media/calendar-icon.ccd3e2b4.svg";